<template>
  <v-chart class="chart" :option="option" v-if="!loadingMap" />
</template>

<script>
import { use, registerMap } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { MapChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  VisualMapComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  MapChart,
  TitleComponent,
  TooltipComponent,
  VisualMapComponent,
]);

var itemStyle = {
  normal: {
    borderColor: "rgba(100,149,237,1)",
    borderWidth: 0.5,
    areaColor: "#eaf2fc",
    areaStyle: {
      color: "#eaf2fc",
    },
  },
  emphasis: {
    label: { show: true },
  },
};

export default {
  components: {
    VChart,
  },
  props: ["data"],
  provide: {
    [THEME_KEY]: "dark",
  },
  data() {
    return {
      loadingMap: true,
      option: {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return params.name + " : " + (params.value || 0);
          },
        },
        visualMap: {
          min: 0,
          max: 1,
          text: ["High", "Low"],
          realtime: false,
          calculable: true,
          inRange: {
            color: ["#eaf2fc", "#292961"],
          },
          show: false,
        },
        series: [
          {
            type: "map",
            map: "world",
            roam: true,
            width: "95%",
            itemStyle,
            data: this.data.map((r) => ({
              name: r.x,
              value: r.y,
            })),
          },
        ],
      },
    };
  },
  async created() {
    const map = await (await fetch("/world.json")).json();
    this.loadingMap = true;
    registerMap("world", map);
    this.loadingMap = false;
  },
};
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>